module.exports = __webpack_public_path__ + "img/img_lianghua_jihua_two@3x.696a87b1.png";